import { supabase } from "@/integrations/supabase/client";

export type AutomationHookKind = "n8n" | "zapier";

export type WorkspaceAutomationHook = {
  id: string;
  workspace_id: string;
  kind: AutomationHookKind;
  webhook_url: string;
  enabled: boolean;
  last_fired_at: string | null;
  last_status: string | null;
  last_error_message: string | null;
  created_at: string;
  updated_at: string;
};

const invoke = async <T,>(body: Record<string, unknown>): Promise<T> => {
  const { data, error } = await supabase.functions.invoke("workspace-automation-manage", { body });
  if (error) throw new Error((error as { message?: string }).message ?? "Request failed");
  if (data?.error) throw new Error(data.error);
  return data as T;
};

export const listAutomationHooks = async (workspaceId: string): Promise<WorkspaceAutomationHook[]> => {
  const data = await invoke<{ hooks: WorkspaceAutomationHook[] }>({
    action: "list",
    workspace_id: workspaceId,
  });
  return data.hooks ?? [];
};

export const upsertAutomationHook = async (
  workspaceId: string,
  kind: AutomationHookKind,
  webhookUrl: string,
  enabled: boolean,
): Promise<WorkspaceAutomationHook> => {
  const data = await invoke<{ hook: WorkspaceAutomationHook }>({
    action: "upsert",
    workspace_id: workspaceId,
    kind,
    webhook_url: webhookUrl,
    enabled,
  });
  return data.hook;
};

export const deleteAutomationHook = async (
  workspaceId: string,
  kind: AutomationHookKind,
): Promise<void> => {
  await invoke({ action: "delete", workspace_id: workspaceId, kind });
};

export const testAutomationHook = async (
  workspaceId: string,
  kind: AutomationHookKind,
): Promise<{ ok: boolean; http_status: number | null; error: string | null }> => {
  return await invoke<{ ok: boolean; http_status: number | null; error: string | null }>({
    action: "test",
    workspace_id: workspaceId,
    kind,
  });
};
